import { QueryClient } from '@tanstack/react-query';
import type { UploadAssetDomain } from './uploadAssetDomain';

export const assetQueryKeys = {
  compliance_documents: {
    root: ['compliance-documents'] as const,
    folderStructure: ['compliance-documents-folder-structure'] as const,
    byFolder: ['compliance-documents-by-folder'] as const,
    flat: ['compliance-documents-flat'] as const,
    resourcesSearch: ['compliance-documents-search'] as const,
    unifiedSearchPropositions: [
      'unified-search-propositions',
      'compliance_documents',
    ] as const,
    globalSearch: ['global-search', 'compliance-documents'] as const,
    coverage: ['compliance-coverage'] as const,
  },
  marketing_assets: {
    root: ['marketing-assets'] as const,
    folderStructure: ['marketing-assets-folder-structure'] as const,
    byFolder: ['marketing-assets-by-folder'] as const,
    flat: ['marketing-assets-flat'] as const,
    resourcesSearch: ['marketing-assets-search'] as const,
    unifiedSearchPropositions: [
      'unified-search-propositions',
      'marketing_assets',
    ] as const,
    globalSearch: ['global-search', 'marketing-assets'] as const,
  },
} as const satisfies Record<
  UploadAssetDomain,
  Record<string, readonly unknown[]>
>;

const invalidationPrefixes: Record<
  UploadAssetDomain,
  readonly (readonly unknown[])[]
> = {
  compliance_documents: [
    assetQueryKeys.compliance_documents.root,
    assetQueryKeys.compliance_documents.folderStructure,
    assetQueryKeys.compliance_documents.byFolder,
    assetQueryKeys.compliance_documents.flat,
    assetQueryKeys.compliance_documents.resourcesSearch,
    assetQueryKeys.compliance_documents.unifiedSearchPropositions,
    assetQueryKeys.compliance_documents.globalSearch,
    assetQueryKeys.compliance_documents.coverage,
  ],
  marketing_assets: [
    assetQueryKeys.marketing_assets.root,
    assetQueryKeys.marketing_assets.folderStructure,
    assetQueryKeys.marketing_assets.byFolder,
    assetQueryKeys.marketing_assets.flat,
    assetQueryKeys.marketing_assets.resourcesSearch,
    assetQueryKeys.marketing_assets.unifiedSearchPropositions,
    assetQueryKeys.marketing_assets.globalSearch,
  ],
};

export async function invalidateAssetQueries(
  queryClient: QueryClient,
  domain: UploadAssetDomain,
): Promise<void> {
  await Promise.all(
    invalidationPrefixes[domain].map((queryKey) =>
      queryClient.invalidateQueries({ queryKey }),
    ),
  );
}
